import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetAllChapterQuery } from "App/services/chapterServiceApi";
import { useCreateQuestionMutation } from "App/services/QuestionServiceApi";
import Loading from "components/Loading";
// import JoditEditor from "jodit-react";
import { toast } from "react-toastify";
// import { config } from "components/EditorConfig";
import EditorComponents from "components/Editor/EditorComponents";
import JoditEditor from "jodit-react";
import ChapterDragDrop from "./ChapterDragDrop";
import useFeatureEnabled from "components/FeatureToggle/useFeatureEnabled";

export default function QuestionFormDialogue({ open, onClose }) {
  const editor = React.useRef(null);
  // const editorRef = useRef(null);

  const location = useLocation();
  const data = location.state || {};
  // console.log(data)
  // const [open, setOpen] = React.useState(false);
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [chapterId, setChapterId] = useState(data.data);
  const [categoryId, setCategoryId] = useState(data.categoryId);
  const [appliedChapters, setAppliedChapters] = useState([]);
  const multiChapterEnabled = useFeatureEnabled("multi_chapter_questions");

  const {
    data: allChapters,
    error: questionsError,
    isLoading: questionsLoading,
  } = useGetAllChapterQuery();
  const [createQuestion, { isLoading }] = useCreateQuestionMutation();

  useEffect(() => {
    if (data.data && allChapters && allChapters.length > 0) {
      const currentId = Number(data.data);
      const current = allChapters.find((c) => c.id === currentId);
      setAppliedChapters(current ? [current.id] : [currentId]);
    }
  }, [data.data, allChapters]);

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    onClose(false);
  };

  const handleAddQuestion = async (event) => {
    event.preventDefault();
   

    if ((question, answer)) {

      let newQuestion = question.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')
      let newAnswer = answer.split('<p data-f-id="pbf" style="text-align: center; font-size: 14px; margin-top: 30px; opacity: 0.65; font-family: sans-serif;">Powered by <a href="https://www.froala.com/wysiwyg-editor?pb=1" title="Froala Editor">Froala Editor</a></p>')
      const chapterIds = multiChapterEnabled
        ? (appliedChapters.length > 0 ? appliedChapters : [chapterId].filter(Boolean))
        : [chapterId].filter(Boolean);
      try {

        await createQuestion({
          que: newQuestion[0],
          answer: newAnswer[0],
          video_link: videoLink,
          chapterId: chapterIds[0],
          categoryId,
          chapters: chapterIds,
        });
        toast.success("Question Successfully Created!");
        handleClose();
        setQuestion("");
        setAnswer("");
        setVideoLink("");
      } catch (error) {
        toast.error("Something went wrong!!");
      }
    } else {
      toast.error("Required to question and answer");
    }
  };

  if (questionsError) {
    return <div>Error: {questionsError.message}</div>;
  }

  // const handleQuestionEditorChange = (content) => {
  //   setQuestion(content);
  // };

  return (
    <div>
      {/* <Button variant="contained" color="light" onClick={handleClickOpen}>
        Add Question
      </Button> */}

      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{
          component: "form",
          onSubmit: handleAddQuestion,
          style: { width: "60%", maxWidth: "none" },
        }}
      >
        <DialogTitle>Add Question</DialogTitle>
        <DialogContent>
          <DialogContentText>
            To add a new question, please fill out the form below.
          </DialogContentText>

          <label>Question</label>
          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={question}
            init={init}
            onEditorChange={newContent => setQuestion(newContent)}
          /> */}

          <JoditEditor
            ref={editor}
            value={question}
            // config={config}
            onChange={newContent => setQuestion(newContent)}
          />
          {/* <EditorComponents  
            content={question}
            handleChangeContent={(newContent) => setQuestion(newContent)}
          /> */}

          <label>Answer</label>
          {/* <Editor
            apiKey={`${EDITOR_API_KEY}`}
            onInit={(_evt, editor) => (editorRef.current = editor)}
            initialValue={answer}
            init={init}
            onEditorChange={newContent => setAnswer(newContent)}
          /> */}
          <JoditEditor
            ref={editor}
            value={answer}
            // config={config}
            onChange={newContent => setAnswer(newContent)}
          />

          {/* <EditorComponents
            content={answer}
            handleChangeContent={(newContent) => setAnswer(newContent)}
          /> */}

          <TextField
            margin="dense"
            id="videoLink"
            label="Video Link"
            fullWidth
            variant="outlined"
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />

          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Chapter Applied
            </Typography>
            {questionsLoading ? (
              <Typography variant="body2" color="text.secondary">
                Loading chapters...
              </Typography>
            ) : multiChapterEnabled ? (
              <ChapterDragDrop
                chapters={allChapters || []}
                value={appliedChapters}
                onChange={setAppliedChapters}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                {allChapters?.find((c) => c.id === Number(chapterId))?.name || "Single chapter"}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>

          <Button type="submit" disabled={isLoading} name="submit">
            Add {isLoading && "Loading..."}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
